import React from 'react';
import {FormControlLabel, FormGroup, Switch} from '@mui/material';
import {observer} from 'mobx-react';
import uiStore from "../lib/stores/uiStore";

const UiSettings = () => {

    return <div>
        <FormGroup sx={{padding: "15px"}}>
            <FormControlLabel
                    control={
                        <Switch
                                checked={uiStore.messagesVisible}
                                onChange={(event, checked) => {
                                    uiStore.messagesVisible = checked;
                                }}/>}
                    label="Messages visible"
            />
            <FormControlLabel
                    control={
                        <Switch
                                checked={uiStore.debugModeEnabled}
                                onChange={(event, checked) => {
                                    uiStore.debugModeEnabled = checked;
                                }}/>}
                    label="Debug mode"
            />
        </FormGroup>
    </div>
};

export default observer(UiSettings);
